import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import CareimageModel from "@/commons/models/Careimage";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * 介護記録 API 操作クラス
 */
export default class Careimages {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET Careimages
   */
  public async get(userStore: LoginUser, queryParams: { start: number; end: number }, residentId?: number): Promise<Array<CareimageModel>> {
    let requestUrl: string = "";

    // 施設IDのみの場合のURL作成
    if (!residentId) {
      const formatParams: any = {
        facilityId: userStore.facility.id
      };
      requestUrl = UrlFormatter.format(RestUrl.CareimagesInFacility, formatParams);
    }
    // 施設ID、利用者IDの場合のURL作成
    else if (residentId) {
      const formatParams: any = {
        facilityId: userStore.facility.id,
        residentId: residentId
      };
      requestUrl = UrlFormatter.format(RestUrl.Careimages, formatParams);
    }
    const response = await this.commonService.executeGet<Array<CareimageModel>>(userStore, requestUrl, this.constructor.name, queryParams, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * POST Careimages
   */
  public async post(userStore: LoginUser, residentId: number, careimage: CareimageModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      residentId: residentId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.Careimages, formatParams);

    // APIのモデルに合わせてここで送信内容を調整
    const requestBody: any = {
      datetime: careimage.datetime,
      residentRoom: careimage.residentRoom,
      residentName: careimage.residentName,
      writerId: careimage.writerId,
      writtenBy: careimage.writtenBy,
      images: careimage.imageUrls
    };

    const response = await this.commonService.executePost<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * DELETE Careimages
   */
  public async delete(userStore: LoginUser, residentId: number, careimageDate: number): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      residentId: residentId,
      careimageDate: careimageDate
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.Careimage, formatParams);
    const response = await this.commonService.executeDelete<any>(userStore, requestUrl, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}
